<template>
  <div class="project-list-remote">
    <!-- Loader overlay -->
    <v-overlay :value="!isLoaded">
      <v-progress-circular indeterminate size="64" />
      <!-- <v-progress-circular
        :rotate="360"
        :size="100"
        :width="15"
        :value="completePercetage"
        color="primary"
      >
        {{ completePercetage }} %
      </v-progress-circular> -->
    </v-overlay>

    <template v-if="isLoaded">
      <v-col cols="12">
        <v-text-field v-model="search" label="Recherche Nom ou Prénom" outlined />
      </v-col>

      <v-data-table v-model="selectedProjects" item-key="uuid" :headers="headers" :items="localProjects"
        :options.sync="pagination" :server-items-length="totalProjects" :footer-props="footerOptions"
        :items-per-page="500" show-select show-expand>
        <template #item="{ item, isSelected, select }">
          <tr :class="{ locked: item.idc_locked && isApplicator }">
            <td class="text-start">
              <v-simple-checkbox :value="isSelected" @input="select($event)" />
            </td>
            <td class="text-start">
              {{ item.patient.fullname }} <br>
              <span>{{ item.center }}</span>
            </td>
            <td class="text-start">
              {{ item.product_name }}
            </td>
            <td class="text-start">
              {{ item.created_at | removeTime }}
            </td>
          </tr>
        </template>
      </v-data-table>

      <app-bottom-nav @click-first="saveSelectedProjects" @click-second="$router.push('projects-list-local')">
        <template #first>
          Enregistrer
        </template>
        <template #second>
          Base Tablette
        </template>
      </app-bottom-nav>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { productsModelObject } from "@/mixins/productsModelObject.js";
import { synchronization } from "@/mixins/synchronization.js";
import ErrorHandlingMixin from "@/mixins/ErrorHandlingMixin.vue";

import { AppBottomNav } from "../../shared/components";

export default {
  name: "AppProjectsListRemote",

  components: {
    AppBottomNav
  },

  mixins: [synchronization, ErrorHandlingMixin, productsModelObject],

  data() {
    return {
      isLoaded: false,
      // projects: [],
      search: "",
      selectedProjects: [],
      counter: 0,
      completePercetage: 0,
      errorCounter: 0,

      headers: [
        {
          text: "Patient",
          value: "patient.fullname",
          sortable: false
        },
        {
          text: "Fiche",
          value: "product_name"
        },
        {
          text: "Date",
          value: "created_at"
        },
        { text: "", value: "data-table-expand" }
      ],

      footerOptions: {
        itemsPerPageOptions: [100, 500, 1000]
      }
    };
  },

  computed: {
    ...mapState({
      projects: state => state.projects.projects,
      loading: state => state.projects.loading
    }),

    isApplicator() {
      return this.$store.state.auth.user.role === "APPLICATOR";
    },

    // Rework array to add custom props
    localProjects() {
      if (this.projects && this.projects.length > 0) {
        return this.projects.map(project => {
          // Adding product_name prop that holds a string
          project.product_name = this.productsModelObject()[
            project.product_model
          ].name;
          return project;
        });
      }

      // Empty array if null or empty
      return [];
    },

    // Pagination options
    pagination: {
      get() {
        return this.$store.state.projects.pagination;
      },

      set(options) {
        this.$store.commit("projects/UPDATE_PAGINATION", options);
      }
    },

    ...mapGetters({
      totalProjects: "projects/totalProjects"
    })
  },

  watch: {
    // Watch for pagination changes
    pagination: {
      deep: true,
      async handler() {
        await this.fetchProjects();
        this.$vuetify.goTo(0); // Go to top of the page
      }
    },

    // Watch for search changes
    search: {
      deep: true,
      async handler() {
        if (this.search.length >= 3 || this.search.length <= 0) {
          await this.fetchProjects();
        }
      }
    }
  },

  created() {
    this.init();
  },

  methods: {
    // Initialize data
    async init() {
      // Set loading state
      this.isLoaded = false;

      try {
        await this.fetchProjects();
        await this.getProjectsFromIndexedDB();
      } catch (error) {
        alert(error);
      } finally {
        this.isLoaded = true;
      }
    },

    // Get IndexedDB projects
    async getProjectsFromIndexedDB() {
      return await this.$db.projects.each(project => {
        // Check if projects was already sented
        if (project.server_version && project.server_version !== "") {
          this.selectedProjects.push(project);
        }
      });
    },

    // Fetch projects
    async fetchProjects() {
      try {
        // Get pagination data
        const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;

        let params = {
          page,
          itemsPerPage,
          sortBy,
          sortDesc
        };

        // Manage search filtering
        if (this.search.length >= 3) {
          params.search = this.search;
        }

        // Do fetch projects request
        return await this.$store.dispatch("projects/fetchProjects", params);
      } catch (error) {
        // No internet
        if (error.message.match(/Network Error/)) {
          this.handleError(
            error,
            "La connexion avec la Base serveur a échouée. Veuillez réessayer plus tard"
          );
        } else {
          throw error;
        }
      }
    },

    // Save selected projects in storage
    async saveSelectedProjects() {
      // TODO: Remove try/catch 'cause here it is useless
      try {
        // Set to loading state
        // TODO: put that on vuex 'cause it's used in various components
        this.isLoaded = false;

        // Handles unchecked projects deletion
        this.deleteUncheckedProjects();

        // Loop through checked projects
        for (let i = 0; i < this.selectedProjects.length; i++) {
          const element = this.selectedProjects[i];
          try {
            // Get project from indexed DB by uuid
            // if true, that's mean project already saved in indexed db so just skip to next project
            const project = await this.$db.projects.get(element.uuid);
            if (project) continue;

            // First step, save project
            await this.saveProject(element);

            // Second step, save medias
            await this.saveMedias(element);

            // Third and last step, save product
            await this.saveProduct(element);

            this.counter++;
          } catch (err) {
            // Print out the error
            console.log(err);

            // There is an error for this element, delete all related data from indexed DB
            this.rollback(element);

            // Error counter
            this.errorCounter++;

            // Go to next iteration
            continue;
          }

          // Calculate and round total percentage
          this.completePercetage = (
            (this.counter / this.selectedProjects.length) *
            100
          ).toFixed();
        }

        // Set notification message
        // TODO: maybe need a rework
        let notifcationMessage = `${this.counter} projets ont été enregistrés.`;
        if (this.errorCounter > 0) {
          notifcationMessage = notifcationMessage.concat(
            " ",
            `Cependant ${this.errorCounter
            } fiches n'ont pas pu être enregitrées.`
          );
        }

        // FIre notifiation
        this.$notify({
          group: "main",
          type: "success",
          title: "Projets enregistrés !",
          text: notifcationMessage,
          duration: 5000
        });
      } finally {
        // Stop loading state and reset counters
        this.isLoaded = true;
        this.errorCounter = 0;
        this.counter = 0;
        this.completePercetage = 0;
      }
    },

    // Save project + patient
    async saveProject(project) {
      try {
        // Try to get patient from local index
        const patientKey = await this.$db.patients.get(project.patient.uuid);

        // Add patient if not present in local db
        if (!patientKey) {
          await this.$db.patients.add(project.patient);
        }

        // Check if project already exist in local db
        const projectKey = await this.$db.projects.get(project.uuid);

        // Add project if not present in local db
        if (!projectKey) {
          // Fetch project from Api
          const projectFromApi = await this.$store.dispatch(
            "projects/fetchProject",
            project.uuid
          );

          // Set prop to keep track of product versioning
          projectFromApi.local_version = null;
          projectFromApi.server_version = project.product_uuid;

          // Save project in local db
          await this.$db.projects.add(projectFromApi);
        }
      } catch (error) {
        throw error;
      }
    },

    // Save project medias
    async saveMedias(project) {
      try {
        for (const media of project.medias) {
          const mediaFromApi = await this.$store.dispatch("medias/fetchMedia", {
            project_uuid: project.uuid,
            media_uuid: media.uuid
          });

          // Deep clone
          let mediaToStore = JSON.parse(JSON.stringify(mediaFromApi));
          mediaToStore.project_uuid = project.uuid;

          // Check if we need to fetch an image
          if (mediaToStore.has_image) {
            // Fetch image media
            const imageMediaFromApi = await this.$store.dispatch(
              "medias/fetchImageMedia",
              {
                project_uuid: project.uuid,
                media_uuid: mediaToStore.uuid
              }
            );

            mediaToStore.image = imageMediaFromApi.image;
          }

          const mediaKey = await this.$db.medias.get(mediaToStore.uuid);

          if (!mediaKey) {
            await this.$db.medias.add(mediaToStore);
          }
        }
      } catch (error) {
        throw error;
      }
    },

    // Save project product
    async saveProduct(project) {
      try {
        // Check if there is a product uuid
        if (!project.product_uuid) {
          throw new Error("No product uuid for this project");
        }

        const productsModelObject = this.productsModelObject();
        const tableName = productsModelObject[project.product_model].table;
        // Fetch product from Api
        const productFromApi = await productsModelObject[
          project.product_model
        ].get(project.product_uuid);

        // Deep clone
        const productToStore = JSON.parse(JSON.stringify(productFromApi));

        // Fetch product from local db
        const productKey = await tableName.get(productToStore.uuid);

        // Check if product already exist
        if (!productKey) {
          await tableName.add(productToStore);
        }
      } catch (error) {
        throw error;
      }
    },

    // Delete unchecked projects
    async deleteUncheckedProjects() {
      const projectsFromDB = await this.$db.projects.toArray();

      const newProjectsFromDB = projectsFromDB.filter(
        project => project.server_version && project.server_version !== ""
      );

      const uuidsFromDB = newProjectsFromDB.map(project => project.uuid);
      const uuidsSelected = this.selectedProjects.map(project => project.uuid);

      const uncheckedProjects = uuidsFromDB.filter(
        project => uuidsSelected.indexOf(project) == -1
      );

      for (const project_uuid of uncheckedProjects) {
        const project = await this.$db.projects.get(project_uuid);

        if (project) {
          this.rollback(project);
        }
      }
    },

    // Rollback function
    // Remove project, medias and product
    async rollback(project) {
      // Remove product
      const productsModelObject = this.productsModelObject();
      const tableName = productsModelObject[project.product_model].table;
      await tableName.delete(project.product_uuid);

      // Remove medias
      for (const media of project.medias) {
        await this.$db.medias.delete(media.media_uuid || media.uuid); // TODO: WTF is media_uuid ?????
      }

      // Remove project
      await this.$db.projects.delete(project.uuid);
    }
  }
};
</script>

<style lang="scss">
.project-list-remote {
  display: flex;
  flex-direction: column;
  padding-bottom: 66px;

  .v-data-table {
    flex-grow: 1;

    table {
      border: none !important;

      * {
        border: none !important;
      }

      tbody {
        .locked {
          background-color: #ff6b6b;

          td {
            color: #f7fff7 !important;
          }
        }

        .locked:hover {
          background-color: #ff6b6b !important;
        }

        td {
          font-size: 14px !important;
          padding: 20px 16px !important;

          &:nth-last-child(5) {
            font-weight: bold;
            font-size: 13px !important;
            color: #006064;
            text-transform: uppercase;
          }

          &:nth-last-child(4) {
            font-weight: bold;
            font-size: 13px !important;
            text-transform: uppercase;
            color: #880e4f;
          }

          &:nth-last-child(3) {
            font-weight: 600;
            color: #880e4f;
          }

          &:nth-last-child(2) {
            i {
              font-size: 20px !important;
            }
          }

          span {
            font-weight: 400;
            font-size: 14px;
          }
        }
      }
    }

    .v-data-footer {
      border-top: none !important;
    }
  }
}
</style>
